const PERMISSION_ASKED_KEY = 'kc3.notificationPermissionAsked'

/**
 * Requests the browser's native Notification permission once per browser
 * (tracked via localStorage, not per-agent) — call on app/header mount.
 * No-ops if the browser doesn't support the Notification API, or if we've
 * already asked (regardless of the answer) so we never re-prompt a user
 * who dismissed or denied it.
 */
export function requestNotificationPermissionOnce(): void {
  if (typeof window === 'undefined' || !('Notification' in window)) return
  if (localStorage.getItem(PERMISSION_ASKED_KEY)) return
  if (Notification.permission !== 'default') {
    localStorage.setItem(PERMISSION_ASKED_KEY, '1')
    return
  }
  void Notification.requestPermission().finally(() => {
    localStorage.setItem(PERMISSION_ASKED_KEY, '1')
  })
}

/**
 * Shows a native desktop notification if permission was granted; no-ops
 * (never throws) otherwise — the in-app bell/panel is the fallback and
 * always works independent of this.
 */
export function showBrowserNotification(title: string, body: string): void {
  if (typeof window === 'undefined' || !('Notification' in window)) return
  if (Notification.permission !== 'granted') return
  try {
    new Notification(title, { body })
  } catch {
    // Notification construction can throw in some embedded/webview
    // contexts even when permission is nominally granted — never let
    // this break the in-app notification flow.
  }
}
